import React from 'react';
import { withStyles, Grid, Typography, ButtonBase, } from '@material-ui/core';
import PropTypes from 'prop-types';
import AppUtils from '../../../control/apputlis';
import AppConfig from '../../../control/config';


const backgroud = require("../../../images/change/bg.png");
const close = require("../../../images/icons/guanbi_icon.png");
const close1 = require("../../../images/icons/close1.png");

class Download extends React.Component {

    _isIos = () => {
        var u = navigator.userAgent;
        if (u.indexOf("iPhone") > -1 || u.indexOf("iOS") > -1) {
            return true;
        }
        return false;
    }

    _onDownload = () => {
        console.log('_onDownload', window.ios_download);
        if (this._isIos()) {
            AppUtils.YMPush('MAIN', 'DOWNLOAD-IOS');
            // window.location.href = window.ios_download;
        } else {
            AppUtils.YMPush('MAIN', 'DOWNLOAD-ANDROID');
            // window.location.href = window.android_download;
        }
        window.location.href = AppConfig.lauchUrl;
    }


    render() {
        const { classes } = this.props;
        return (
            <Grid container direction='column' alignItems='center' className={classes.back}>
                <Grid style={{
                    backgroundSize: 'cover',
                    backgroundImage: `url(${backgroud})`,
                    backgroundRepeat: 'no-repeat',
                    width: '90vw',
                    height: '114vw',
                }}>
                    {/* <Grid container direction='row' justify='flex-end' style={{ width: '100%' }}>
                        <ButtonBase onClick={() => this.props.onClose && this.props.onClose()}>
                            <img src={close} style={{ width: 12, height: 12, marginRight: 16, marginTop: 16 }}></img>
                        </ButtonBase>
                    </Grid> */}
                </Grid>
                <ButtonBase onClick={() => this._goDownload()} className={classes.downbtn}>
                    <Typography style={{ color: '#FFF', fontSize: 14 }}>下载APP</Typography>
                </ButtonBase>
                <ButtonBase onClick={() => this.props.onClose && this.props.onClose()}>
                    <img src={close1} style={{ width: 32, height: 32, marginTop: 16 }}></img>
                </ButtonBase>
            </Grid>
        );
    }
}

Download.propTypes = {
    onClose: PropTypes.func.isRequired,
}

export default withStyles((theme) => ({
    back: {
        flex: 1,
        position: 'fixed',
        top: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(115,109,127,0.3)',
        zIndex: 1100,
        justifyContent: 'center',
        alignItems: 'center',
    },
    downbtn: {
        background: 'linear-gradient(135deg, #15A5B6, #3AF23A)',
        height: 45,
        width: 164,
        borderRadius: 22.5,
        marginTop: 32,
    },
}))(Download);